var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.errStatus)?_c('div',{staticClass:"err-msg"},[_c('p',[_vm._v("授权失败")]),_c('p',[_vm._v("请返回APP，重新进入商城")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }